module.exports = __webpack_public_path__ + "static/partner-img5-611574c6b79e94e783268e7ce865a24a.png";